import { create } from 'zustand';

/** Aviso de Salesforce que no frena (`DUPLICIDAD_*`, `GENERO_NO_RECONOCIDO`, `CARGA_PENDIENTE`). */
export interface EmbudoAdvertencia {
  codigo: string;
  mensaje?: string;
  campos: string[];
}

export const soloTextos = (lista: unknown): string[] =>
  Array.isArray(lista) ? lista.filter((item): item is string => typeof item === 'string') : [];

/**
 * `advertencias` de un 200 de contacto, seleccion o pasos. Con el embudo
 * apagado la clave no viene (202 en pasos): lista vacia.
 */
export const advertenciasDe = (respuesta: unknown): EmbudoAdvertencia[] => {
  const lista = (respuesta as { advertencias?: unknown } | null | undefined)?.advertencias;
  if (!Array.isArray(lista)) return [];
  return lista
    .filter(
      (item): item is Record<string, unknown> =>
        !!item && typeof item === 'object' && typeof (item as { codigo?: unknown }).codigo === 'string'
    )
    .map((item) => ({
      codigo: item.codigo as string,
      mensaje: typeof item.mensaje === 'string' ? item.mensaje : undefined,
      campos: soloTextos(item.campos),
    }));
};

/**
 * Advertencias del ultimo paso que contesto el embudo web EOL (US 23704). No
 * frenan: la pantalla siguiente las muestra y el cliente sigue. Cada paso
 * informado reemplaza las del anterior. No se persiste.
 */
interface AvisosEmbudoState {
  avisos: EmbudoAdvertencia[];
  publicar: (avisos: EmbudoAdvertencia[]) => void;
  limpiar: () => void;
}

export const useAvisosEmbudo = create<AvisosEmbudoState>((set) => ({
  avisos: [],
  publicar: (avisos) => set({ avisos }),
  limpiar: () => set({ avisos: [] }),
}));

/** Para la capa de servicios (fuera de React). */
export const publicarAvisosEmbudo = (avisos: EmbudoAdvertencia[]): void =>
  useAvisosEmbudo.getState().publicar(avisos);
